<section class="product-section" id="template_listing">
  <div class="container" *ngIf="products.length > 0">
    <h2 class="section-title">Our Featured Floor Plans</h2>
    <div class="product-grid">
      <div class="product-card" *ngFor="let product of products">
        <img [src]="product.image" [alt]="product.title" class="product-image">
        <div class="product-info">
          <h4 class="product-title">{{product.title}}</h4>
          
          
          <button type="button" class="view-button" (click)="goToPreview(product.id)"><i class="fas fa-eye"></i> Preview</button>
          <button class="product-button" type="button" (click)="openDownload(product)"><i class="fas fa-download"></i> Download Now</button>
        </div>
      </div>
    </div>
    <div class="section-button">
      <button class="cta-button" (click)="goToAll()">View All Floor Plans</button>
    </div>
  </div>
  <div *ngIf="products.length === 0" class="text-center py-5">
    <p class="fs-20 fw-500">No Templates Found</p>
  </div>
</section>

